import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux';
import { api_call, console_log, copyObject, empty, get_data_value, is_null, returnMobileApp } from '../helpers/untils';
import {
  Button, TextField, Typography, Box, Checkbox, Snackbar, makeStyles,
  TableContainer, Table, TableRow, TableCell, TableHead, TableBody, IconButton,
  ButtonBase
} from '@material-ui/core';

import { Select, MenuItem } from '@material-ui/core';

import { Stack } from '@mui/material';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';

import CloseIcon from '@material-ui/icons/Close';
import AddIcon from '@material-ui/icons/Add';
import SaveIcon from '@material-ui/icons/Save';
import DoneAllIcon from '@material-ui/icons/DoneAll';
import TitleIcon from '@mui/icons-material/Title';
import moment from 'moment';

import ConfirmDialog from '../components/ConfirmDialog';
import { APP_NAME, DEFAULT_M_SOUND, DISTANCE_UNIT_LIST, MAINT_VIDEO_ID, NOTIFICATION_SOUND_LIST } from '../config/constant';
import { sleep } from '../helpers/misc';
import SelectField from '../form/SelectField';
import UserMaintActionDialog from './UserMaintActionDialog';

const useStyles = makeStyles({
  maintItem: {
    padding: '8px 16px',
    border: '2px solid rgb(19, 16, 16)',
    borderRadius: '8px',
  }
});

const UserMaintListTable = (props) => {
  const { open, setOpen, deviceId, deviceItem, setDeviceItem, showDeviceMaintSettingModal } = props
  const user = useSelector((state) => state.session.user);
  const classes = useStyles();
  const history = useHistory();
  const [pageLoading, setPageLoading] = useState(false);
  const defaultItemList = [];
  const [itemList, setItemList] = useState(defaultItemList);
  const [dialogOpen, setDialogOpen] = useState(false);

  const loadPageData = async () => {
    setPageLoading(true)
    const url = `/api/user-maint/${deviceId}`
    const response = await api_call(url);
    if (response.ok) {
      const responseObj = await response.json();
      if (responseObj['maintItemList']) {
        setItemList(responseObj['maintItemList']);
      }
    }
    setPageLoading(false)
  }

  useEffect(() => {
    loadPageData();
  }, [deviceId]);

  const showToast = (msg) => {
    setToastMessage(msg)
    setSnackbarOpen(true)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  const [currentItem, setCurrentItem] = useState();
  const [hideCarsTrip, setHideCarsTrip] = useState(false);

  const onClickMaintItem = (item) => {
    console.log(`onClickMaintItem:::, item`, item);
    setCurrentItem(item);
    setDialogOpen(true);
  }

  const onClickHideCarsTrip = async () => {
    setHideCarsTrip(!hideCarsTrip);
  }

  const onClickDetails = async () => {
    showDeviceMaintSettingModal();
  }

  const onClickTicon = async (e, item) => {
    console.log(`onClickTicon:::::::`, item);
    e.stopPropagation();
    if (item.tripLinkUrls) {
      item.tripLinkUrls.forEach((url, index) => {
        setTimeout(() => {
          window.open(url, '_blank', 'noopener,noreferrer');
        }, index * 100); // delay between each tab
      });
    }
  }

  return (
    <React.Fragment>
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={snackbarOpen}
          onClose={() => { setSnackbarOpen(false) }}
          autoHideDuration={1500}
          message={toastMessage}
        />
        <Box sx={{ mb: 2 }}>
          <Stack style={{ width: '100%' }} spacing={2}>
            <Button variant="outlined" color="primary" onClick={() => onClickHideCarsTrip()}>
              {`${hideCarsTrip ? 'Show' : 'Hide'} Cars on a Trip`}
            </Button>
            {
              itemList.filter(item => hideCarsTrip ? (item.hasActiveTripLnks !== 1) : true).map((item, index) => {
                return (
                  <ButtonBase key={index} disableRipple className={[classes.maintItem]} style={{ borderColor: item?.status?.color }} onClick={() => onClickMaintItem(item)}>
                    <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={1} style={{ width: '100%' }}>
                      <Box>
                        <Typography>{item.label}</Typography>
                      </Box>
                      <Box>
                        {
                          (item.user_action === 'done') ? (
                            <ButtonBase><DoneAllIcon /></ButtonBase>
                          ) : (item.hasActiveTripLnks === 1) ? (
                            <ButtonBase onClick={(e) => onClickTicon(e, item)}><TitleIcon /></ButtonBase>
                          ) : (<></>)
                        }
                      </Box>
                    </Stack>
                  </ButtonBase>
                )
              })
            }
            <Button variant="outlined" color="primary" onClick={() => onClickDetails()}>
              Details
            </Button>
          </Stack>
        </Box>
      </div>

      <>
        <UserMaintActionDialog
          open={dialogOpen}
          setOpen={setDialogOpen}
          history={history}
          device={deviceItem}
          item={currentItem}
          showToast={showToast}
          itemList={itemList}
          setItemList={setItemList}
        />
      </>

    </React.Fragment>
  )
}

export default UserMaintListTable;